import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import serverTimestamp from '../utilities/Data/serverTimestamp'
import getPostByPostId from './getPostByPostId'

const getPostCommentsByPostId = async ({ postId }) => {
	if (!postId) {
		throw errorOfType(errorTypes.KEYNOTSPECIFIED, 'getPostCommentsByPostId')
	}
	try {
		const postResult = await getPostByPostId({ postId })
		const post = postResult && postResult.post
		const postCommentsDocSnap = await firestore.collection('posts').doc(postId).collection('comments')
			.orderBy('createdTimestamp', 'asc')
			.get()

		const captionComment = post && post.caption && {
			text: post.caption,
			createdTimestamp: serverTimestamp(post.createdTimestamp),
			userName: post.userName,
			isPostCaption: true
		}

		let postComments = captionComment ? [captionComment] : []

		const existingComments = postCommentsDocSnap.docs.map((d) => {
			const data = d.data()
			data.createdTimestamp = serverTimestamp(data.createdTimestamp)
			if (data.modifiedTimestamp) {
				data.modifiedTimestamp = serverTimestamp(data.modifiedTimestamp)
			}
			return data
		}).filter(comment => !comment.deleted)

		postComments = postComments.concat(existingComments)

		return { postComments, post }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, postId, exception)
	}
}

export default getPostCommentsByPostId



// WEBPACK FOOTER //
// ./src/dataservices/getPostCommentsByPostId.js